import { combineReducers } from 'redux';

import { reducer as formEntryReducer } from './formEntry/reducer';
import { reducer as mediaAlphaReducer } from './mediaAlpha/reducer';

export default combineReducers({
	formEntry: formEntryReducer,
	additionalProviders: mediaAlphaReducer
});
